import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { useLoginByVerifyLink } from '../hooks';
import { useGetRouteParams } from '../hooks/tanstack/useUtilsHook';

import LoginByLinkFail from './LoginByLinkFail';

function LoginByLinkVerify() {
  const { token } = useGetRouteParams();

  const [status, setStatus] = useState<'success' | 'pending' | 'failed' | null>(
    null
  );

  const navigate = useNavigate();

  const { mutate } = useLoginByVerifyLink({
    onSuccess: () => {
      setStatus('success');
      navigate('/', { replace: true });
    },
    onError: () => {
      setStatus('failed');
    },
  });

  useEffect(() => {
    setStatus('pending');
  }, []);

  useEffect(() => {
    if (status === 'pending' && token) {
      const data = {
        token,
      };

      mutate({ data });
    }
  }, [token, status]);

  if (status === 'failed') {
    return <LoginByLinkFail />;
  }

  return <div className="bg-blue-950 h-screen w-screen" />;
}

export default LoginByLinkVerify;
